import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LoaderState } from '@app/models/common/loaderState';
import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/observable/interval';

@Injectable()
export class LoaderService {
    private loaderSubject = new Subject<LoaderState>();
    loaderState = this.loaderSubject.asObservable();
    count: number = 0;
    constructor() { }
    show() {

        this.loaderSubject.next(<LoaderState>{ show: ++this.count });
    }
    hide() {

        this.loaderSubject.next(<LoaderState>{ show: --this.count });
    }

    checkUserSessionIdleTime() {
        return Observable.create((observer) => {
            setInterval(() => {
                observer.next();
            }, 100);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/shared/loader.service.ts